/**
 * <crossword>
 * -----------------------------------------------------------------------------
 *
 * @type {Component}
 *
 * -----------------------------------------------------------------------------
 */

parasails.registerComponent('crossword', {

  //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔═╗╦═╗╔═╗╔═╗╔═╗
  //  ╠═╝║ ║╠╩╗║  ║║    ╠═╝╠╦╝║ ║╠═╝╚═╗
  //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩  ╩╚═╚═╝╩  ╚═╝
  props: [
    'grid',
    'answergrid',
    'hints',
    'hintsmessage',
    'bonusgrid',
    'bonusmode',
    'bonusanswer',
    'crosswordindex',
    'currentanswergrid'
  ],

  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: function () {
    return {
      puzzleComplete: false,
      letterStyle: 'letter',
      bonusStyle: ['bonus-letter bl0', 'bonus-letter bl1', 'bonus-letter bl2', 'bonus-letter bl3', 'bonus-letter bl4', 'bonus-letter bl5', 'bonus-letter bl6', 'bonus-letter bl7', 'bonus-letter bl8', 'bonus-letter bl9'],
      pendingStyle: 'pending',
      correctStyle: 'correct',
      bonusLetters: [],
      showCrosswordInput: false,
      currentSelectedHint: {
        hint: '',
        letters: 0,
        crosswordindex: 0,
        questionnumber: 0,
      },
      currentAnswersGrid: [],
      replacementChars: {'ゃ':'や','ゅ':'ゆ','ょ':'よ','っ':'つ','ぁ':'あ','ぃ':'い','ぅ':'う','ぇ':'え','ぉ':'お','ゎ':'わ','ヵ':'カ','ヶ':'ケ'},
      currentBonusCounter: -1,
      localhintsmessage: ''
    };
  },


  //  ╦ ╦╔╦╗╔╦╗╦
  //  ╠═╣ ║ ║║║║
  //  ╩ ╩ ╩ ╩ ╩╩═╝

  template: `
  <div class="crossword">
    <div class="row" v-for="(gridrow, gridrowindex) in grid" :key="gridrowindex">
      <div v-for="(gridcol, gridcolindex) in gridrow" :key="gridcolindex">
        <div v-if="gridcol === '0'" class="square empty"></div>
        <div v-else-if="gridcol.startsWith('*')" class="square bonusletter hidden" :id="'BONUSPARENT-' + gridcol.replace('*', '')">
          <div v-if="bonusmode === true" class="bonuscharacter" :id="'BONUS-' + gridcol.replace('*', '')">
            <!-- <span v-if="bonusmode === true" class="question_number">
              {{gridcol.replace('*', '')}}
            </span> -->
          </div>
          <div v-else class="square empty"></div>
        </div>
        <div v-else class="square" :class="[isBonus(gridrowindex, gridcol, gridcolindex) ? 'bonus-letter' : letterStyle]" :id="'BONUSLETTERPARENT-' + gridrowindex + '-' + gridcolindex">
          <div v-if="isFirst(gridrowindex, gridcol, gridcolindex) !== ''">
            <input class="crosswordinput firstcrosswordinput" maxlength="1" @click="crosswordInputClicked(gridcol, gridcolindex, gridrowindex)" @keyup="crosswordkeypressed(gridrowindex + '-' + gridcolindex)" :name="gridcol" :id="gridrowindex + '-' + gridcolindex" :ref="gridrowindex + '-' + gridcolindex" autocomplete="off">
            </input>
            <span class="question_number">
              Q{{isFirst(gridrowindex, gridcol, gridcolindex)}}
            </span>
          </div>
          <input v-else class="crosswordinput" maxlength="1" @keyup="crosswordkeypressed(gridrowindex + '-' + gridcolindex)" :id="gridrowindex + '-' + gridcolindex" :ref="gridrowindex + '-' + gridcolindex" autocomplete="off">
          </input>
        </div>
      </div>
    </div>
    <div v-if="bonusmode === true" class="bonuspanel">
      <div v-for="(bn, bnindex) in bonusLetters" class="squarebig bonuscharacterbig" :key="bnindex" :class="'bl' + bnindex" :id="'BONUSBIG-' + bnindex">

      </div>
    </div>
    <div v-if="puzzleComplete === true" class="puzzlecomplete" @click="completeMessageClicked">
      <!-- <span class="fa fa-check-circle"></span> -->
      <!-- <h1>「{{bonusanswer}}」</h1> -->
      <!-- <h2>は</h2> -->
      <!-- <p class="puzzlecompletetext">正解！</p> -->
      <!-- <h1>正解！</h1> -->
      <img class="puzzlecomplete-stamp" src="images/crossword_yy20/clear_text.webp">
      <img class="puzzlecomplete-stamp" src="images/crossword_yy20/stamp_02.png">

      <!-- Gift Code -->
      <div class="giftcode-text">引換コード</div>
      <div class="giftcode">
      {{this.$parent.giftCode}}
      <div v-if="this.$parent.giftReceived === true" class="giftreceivedstamp2"><img src="images/giftexchange/ReceivedStamp.png"></div>
      </div>

      <p class="puzzlecompletetext">この画面をスタッフに見せて<br>オリジナルグッズを受け取ろう！</p>
      <!-- <button class="btn btn-crosswordcomplete btn-success padabit" role="button">次へ</button> -->
    </div>
    <crossword-input v-if="showCrosswordInput == true"
      :inputletters="currentSelectedHint.letters"
      :hinttext="currentSelectedHint.hint"
      :hintsmessage="hintsmessage"
      :crosswordindex="currentSelectedHint.crosswordindex"
      :questionnumber="currentSelectedHint.questionnumber"
      @closeclicked="showCrosswordInput = false;"
      @fillinput="fillInput"></crossword-input>
  </div>
`,

  //<input v-else class="square letter"></input>
  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  mounted: async function() {
    this.setAnswerGrid();
  },

  updated: async function() {
    this.updateBonus();
  },

  beforeDestroy: function() {

  },

  computed: {},

  watch: {},

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {

    //  ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╦  ╦╔═╗╔╗╔╔╦╗  ╦ ╦╔═╗╔╗╔╔╦╗╦  ╔═╗╦═╗╔═╗
    //  ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ║╣ ╚╗╔╝║╣ ║║║ ║   ╠═╣╠═╣║║║ ║║║  ║╣ ╠╦╝╚═╗
    //  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╚╝ ╚═╝╝╚╝ ╩   ╩ ╩╩ ╩╝╚╝═╩╝╩═╝╚═╝╩╚═╚═╝
    setAnswerGrid: function() {
      this.bonusLetters = [];
      this.currentAnswersGrid = [];
      for(var r = 0; r < this.grid.length; r++) {
        this.currentAnswersGrid[r] = [];
        for(var v = 0; v < this.grid[r].length; v++) {
          this.currentAnswersGrid[r][v] = '0';
          if(this.grid[r][v].startsWith('*')) {
            this.bonusLetters.push(this.grid[r][v].replace('*', ''));
          }
        }
      }
    },
    isFirst: function(gridRowIndex, gridCol, colIndex) {
      gridCol = String(gridCol);
      if(gridCol.includes(',')) {
        var numbs = gridCol.split(',');
        for(var n of numbs) {
          if(this.isFirst(gridRowIndex, n, colIndex) === n) {return n;}
        }
      } else {
        for(var r = 0; r < this.grid.length; r++) {
          for(var i = 0; i < this.grid[r].length; i++) {
            // if(this.grid[r][i] === gridCol) {
            if(this.grid[r][i].includes(gridCol)) {
              //First instance of the number...
              if(r === gridRowIndex && i === colIndex) {return gridCol;}
              else {return '';}
            }
          }
        }
      }
      return '';
    },
    isBonus: function(gridRowIndex, gridCol, colIndex) {
      if(this.bonusmode === false) {return false;}

      for(var r = 0; r < this.grid.length; r++) {
        for(var i = 0; i < this.grid[r].length; i++) {
          if(this.bonusgrid[r][i] !== '0' && this.grid[r][i] === gridCol) {
            //First instance of the number...
            if(r === gridRowIndex && i === colIndex) {return true;}
            else {return false;}
          }
        }
      }
      return false;
    },
    updateBonus: function() {
      for(var r = 0; r < this.bonusgrid.length; r++) {
        for(var i = 0; i < this.bonusgrid[r].length; i++) {
          if(this.bonusgrid[r][i] !== '0' && !String(this.grid[r][i]).startsWith('*')) {
            var bonusSlot = this.bonusgrid[r][i];
            var bonusID = 'BONUS-' + bonusSlot;
            var replacementChar = document.getElementById(r + '-' + i).value;
            document.getElementById(bonusID).textContent = replacementChar;
            var bonusIndex = this.bonusLetters.indexOf(bonusSlot);
            document.getElementById('BONUSLETTERPARENT-' + r + '-' + i).className = 'square bonus-letter bl' + bonusIndex;
            document.getElementById('BONUSBIG-' + bonusIndex).textContent = replacementChar;
            if(replacementChar === this.answergrid[r][i]) {
              //document.getElementById('BONUSPARENT-' + bonusSlot).className = 'square bonusletter bl1-correct';
              document.getElementById('BONUSBIG-' + bonusIndex).className = 'squarebig bonusletter bl' + bonusIndex + '-correct';
            } else {
              //document.getElementById('BONUSPARENT-' + bonusSlot).className = 'square bonusletter bl1';
              document.getElementById('BONUSBIG-' + bonusIndex).className = 'squarebig bonusletter bl' + bonusIndex;
            }
          }
        }
      }
    },
    checkSolution: function() {
      var reval = true;
      for(var r = 0; r < this.grid.length; r++) {
        for(var i = 0; i < this.grid[r].length; i++) {
          if(this.grid[r][i] !== '0' && !String(this.grid[r][i]).startsWith('*')) {
            var gottenVal = document.getElementById(r + '-' + i).value;
            if(gottenVal !== null && gottenVal !== undefined) {
              if(gottenVal === '') {
                document.getElementById(r + '-' + i).style='';
                // document.getElementById(r + '-' + i).style='border-radius: 4.5px; background: rgba(0, 0, 0, 0.135)';
                reval = false;
              } else if(this.standardify(gottenVal).toUpperCase() !== this.standardify(this.answergrid[r][i])) {
                this.$emit('crosswordinomplete');
                document.getElementById(r + '-' + i).style='background: #CF1B1B; color: white;';
                // document.getElementById(r + '-' + i).style='border: 2.5px solid red; ; background: rgba(0, 0, 0, 0.1);';
                this.puzzleComplete = false;
                reval = false;
              } else {
                document.getElementById(r + '-' + i).style='';
              }
            }
          }
        }
      }
      if(reval === true) {
        this.$emit('crosswordcomplete');
        this.puzzleComplete = true;
      }
      return reval;
    },
    standardify: function(inputCharacter) {
      //Standardises input of japanese into upper case versions. Used for comparing user input on crossword characters to answers.
      inputCharacter = inputCharacter.replace(/[ゃゅょっぁぃぅぇぉゎヵヶ]/g, m => this.replacementChars[m]);
      return inputCharacter;
    },
    crosswordkeypressed: function() {
      if(this.bonusmode === true) {this.updateBonus();}
      this.puzzleComplete = this.checkSolution();
    },
    crosswordInputClicked: function(questionNumber, grid_column, grid_row) {
      this.currentSelectedHint.id = String(questionNumber);
      if(String(questionNumber).includes(',')) {
        questionNumber = this.isFirst(grid_row, questionNumber, grid_column);
      }
      if(questionNumber === '') { return; }
      questionNumber = parseInt(questionNumber);
      this.$emit('inputclicked', this.crosswordindex, questionNumber);
      this.currentSelectedHint.hint = this.hints[questionNumber - 1].hint;
      this.currentSelectedHint.letters = this.hints[questionNumber - 1].answer.length;
      this.currentSelectedHint.crosswordindex = this.crosswordindex;
      this.currentSelectedHint.questionnumber = questionNumber;
      this.showCrosswordInput = true;
    },

    completeMessageClicked: function() {
      this.$emit('crosswordmessageclicked');
    },
    crosswordCompleteMessageClicked: function() {
      this.$emit('completeclicked');
    },
    fillInput: function(inputText, crosswordindex, questionnumber) {
      //Find question index...
      var questionIndex = 0;
      var isDown = false;
      for(var h = 0; h < this.hints.length; h++) {
        if(parseInt(this.hints[h].questionNumber) === parseInt(questionnumber)) {
          questionIndex = h;
          isDown = this.hints[h].down;
          break;
        }
      }

      var firstbox = document.getElementsByName(this.currentSelectedHint.id)[0];
      var rowcol = firstbox.id.split('-');
      var row = parseInt(rowcol[0]);
      var col = parseInt(rowcol[1]);
      for(var i = 0; i < inputText.length; i++) {
        document.getElementById(row + '-' + col).value = inputText[i];
        if(isDown === true) {
          //Move down by row
          row++;
        } else {
          //Move accrosss by column
          col++;
        }
      }
      this.showCrosswordInput = false;
      this.updateBonus();
      this.checkSolution();
    }
  }
});
